export default {
  Titulo: "Sócio",
  Campos: {
    IdIdentificador: {
      Tipo: "text",
      TipoInput: "hidden"
    },
    CpfCnpj: {
      Tipo: "mask",
      Mascara: "CPFCNPJ",
      Label: "CPF/CNPJ",
      Tooltip: "CPF/CNPJ",
      Obrigatorio: true,
      Tamanho: 25
    },
    Nome: {
      Tipo: "text",
      Label: "Nome",
      Tooltip: "Nome",
      Obrigatorio: true,
      Tamanho: 255
    },
    DataEntrada: {
      Tipo: "date",
      Tooltip: "Data Entrada",
      Label: "Data Entrada",
      Obrigatorio: true
    },
    DataSaida: {
      Tipo: "date",
      Tooltip: "Data Saída",
      Label: "Data Saída",
    },
    Email: {
      Tipo: "text",
      TipoInput: "email",
      Label: "Email",
      Tooltip: "Email",
      Tamanho: 80
    },
    Telefone: {
      Tipo: "mask",
      Mascara: "TELEFONE",
      Label: "Telefone",
      Tooltip: "Telefone",
      Tamanho: 50
    },
    RgIe: {
      Tipo: "text",
      Label: "RG/IE",
      Tooltip: "RG/IE",
      Tamanho: 50,
    }
  }
};